export default [
  // 消息
  {
    path: '/message',
    name: 'message',
    component: () => import('@/CommonDP/pages/mainMg/message'),
    meta: {
      routeName: '消息',
      showSubMenu: true,
      icon: require('@/CommonDP/assets/settings/message.svg')
    },
    children: [
      {
        path: '/allMessage',
        name: 'allMessage',
        component: () => import('@/CommonDP/pages/mainMg/message/message.vue'),
        props: { category: 99 },
        meta: {
          routeName: '全部',
          prouteName: '全部',
          pname: '消息',
          icon1: require('@/CommonDP/assets/settings/allNews.svg'),
          icon2: require('@/CommonDP/assets/settings/allNews.svg')
        }
      },
      {
        path: '/flowMessage',
        name: 'flowMessage',
        component: () => import('@/CommonDP/pages/mainMg/message/message.vue'),
        props: { category: 2 },
        meta: {
          routeName: '流程',
          prouteName: '流程',
          pname: '消息',
          icon1: require('@/CommonDP/assets/settings/flowNews.svg'),
          icon2: require('@/CommonDP/assets/settings/flowNews.svg')
        }
      },
      {
        path: '/annotationMessage',
        name: 'annotationMessage',
        component: () => import('@/CommonDP/pages/mainMg/message/message.vue'),
        props: { category: 1 },
        meta: {
          routeName: '批注',
          prouteName: '批注',
          pname: '消息',
          icon1: require('@/CommonDP/assets/settings/annotationNews.svg'),
          icon2: require('@/CommonDP/assets/settings/annotationNews.svg')
        }
      },
      {
        path: '/proMessage',
        name: 'proMessage',
        component: () => import('@/CommonDP/pages/mainMg/message/message.vue'),
        props: { category: 0 },
        meta: {
          routeName: '项目',
          prouteName: '项目',
          pname: '消息',
          icon1: require('@/CommonDP/assets/settings/projectNews.svg'),
          icon2: require('@/CommonDP/assets/settings/projectNews.svg')
        }
      },
      {
        path: '/taskMessage',
        name: 'taskMessage',
        component: () => import('@/CommonDP/pages/mainMg/message/message.vue'),
        props: { category: 4 },
        meta: {
          routeName: '计划',
          prouteName: '计划',
          pname: '消息',
          icon1: require('@/CommonDP/assets/settings/taskNews.svg'),
          icon2: require('@/CommonDP/assets/settings/taskNews.svg')
        }
      },
      {
        path: '/otherMessage',
        name: 'otherMessage',
        component: () => import('@/CommonDP/pages/mainMg/message/message.vue'),
        props: { category: 3 },
        meta: {
          routeName: '其他',
          prouteName: '其他',
          pname: '消息',
          icon1: require('@/CommonDP/assets/settings/otherNews.svg'),
          icon2: require('@/CommonDP/assets/settings/otherNews.svg')
        }
      }
    ]
  }
];
